import Vue from 'vue'
import VueRouter from 'vue-router'

import App from './App.vue'

import { routes } from './routes';
import ApiService from "./common/api.service";
import 'bootstrap/dist/css/bootstrap.min.css';
import LoadScript from 'vue-plugin-load-script';

import DateTimeFilter from "./common/filters/date/dateTime.filter";
import DateFilter from "./common/filters/date/date.filter";
import TimeFilter from "./common/filters/date/time.filter";
import DayFilter from "./common/filters/date/day.filter";
import TimeAgoFilter from "./common/filters/date/timeAgo.filter";

import VueLazyload from 'vue-lazyload'
import VueSocialSharing from 'vue-social-sharing'
import VueCarousel from '@chenfengyuan/vue-carousel';
import VueYoutube from 'vue-youtube'
import BackToTop from 'vue-backtotop'
import VueMeta from 'vue-meta'

Vue.use(VueMeta);
Vue.use(LoadScript);
Vue.use(VueRouter);
Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: 'https://startbih.ba/assets/images/default/800x600/no_photo.png',
    loading: 'https://thumbs.gfycat.com/ElasticHalfAbyssiniancat-size_restricted.gif',
    attempt: 1
  });
Vue.use(VueSocialSharing);
Vue.use(VueCarousel);
Vue.use(VueYoutube);
Vue.use(BackToTop);


Vue.filter("dateTime", DateTimeFilter);
Vue.filter("date", DateFilter);
Vue.filter("time", TimeFilter);
Vue.filter("day", DayFilter);
Vue.filter("timeAgo", TimeAgoFilter);

ApiService.init();

const router = new VueRouter({
    mode: 'history',
    routes
});

new Vue({
  el: '#app',
  router: router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js